import { render, staticRenderFns } from "./YJSProofOfReading.vue?vue&type=template&id=ffbad526&scoped=true&"
import script from "./YJSProofOfReading.vue?vue&type=script&lang=js&"
export * from "./YJSProofOfReading.vue?vue&type=script&lang=js&"
import style0 from "./YJSProofOfReading.vue?vue&type=style&index=0&id=ffbad526&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffbad526",
  null
  
)

export default component.exports